var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"15d5ffe4991d9ff053a84ec93e81d00e76f8802b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["blue-dot-page@bluedot-tl"]={id:"15d5ffe4991d9ff053a84ec93e81d00e76f8802b"};
      